import React from 'react';
import { FormattedMessage } from 'react-intl';
import { FULFILLMENTS_RECENT_VIEW_ID, FULFILLMENTS_VIEW_ID } from './view-id-constants';

export const FulfillmentsRecent = {
  label: <FormattedMessage defaultMessage='Recent' description='shipping page left nav item for recent fulfillments' id='K2QGW/' />,

  expandedDescription: (
    <FormattedMessage defaultMessage='Fulfillments / Recent' description='shipments page grid header, fulfillments.recent' id='2TRb3I' />
  ),

  id: FULFILLMENTS_RECENT_VIEW_ID,
  navigationOverride: '/shipments/fulfillments/recent',
  parentId: FULFILLMENTS_VIEW_ID,
};
